module.exports = __webpack_public_path__ + "assets/img/logo_small.ea2c1484.png";